/**
 * Route for `igaming-crypto-payment-tracking-usdt-btc-eth-on-pl`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingCryptoPaymentTrackingUsdtBtcEthOnPlPage } from "../features/igaming-crypto-payment-tracking-usdt-btc-eth-on-pl/IgamingCryptoPaymentTrackingUsdtBtcEthOnPlPage";

export const igamingCryptoPaymentTrackingUsdtBtcEthOnPlRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-crypto-payment-tracking-usdt-btc-eth-on-pl",
	component: IgamingCryptoPaymentTrackingUsdtBtcEthOnPlPage,
});

export default igamingCryptoPaymentTrackingUsdtBtcEthOnPlRoute;
